//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import { Splide } from '@splidejs/splide';
import { lockBody, unlockBody } from "./helpers/body-lock-toggle";

function setAccordionCrossClasses(accordionElement, isOpen) {
    let crossOne = accordionElement.querySelector('.cross-p-1');
    let crossTwo = accordionElement.querySelector('.cross-p-2');

    if (crossOne && crossTwo) {
        if (isOpen) {
            crossOne.classList.add('rotate-180');
            crossTwo.classList.add('opacity-0');
            crossTwo.classList.add('rotate-90');
        } else {
            crossOne.classList.remove('rotate-180');
            crossTwo.classList.remove('opacity-0');
            crossTwo.classList.remove('rotate-90');
        }
    }
}

const DefaultSplideConfig = {
    type: 'slide',
    speed: 750,
    perPage: 4,
    perMove: 1,
    arrows: true,
    gap: '2rem',
    padding: { left: '2rem', right: '2rem' },
    breakpoints: {
        1024: {
            perPage: 3,
            padding: {left: '2rem', right: '2rem'},
            gap: '2rem'
        },
        640: {
            perPage: 2,
            padding: {left: '1.5rem', right: '1.5rem'},
        },
        480: {
            perPage: 1,
            padding: {left: '1.5rem', right: '1.5rem'},
        },
    },
}

function closeLightBox(lightbox) {
    lightbox.classList.add('opacity-0');
    lightbox.classList.add('pointer-events-none');
    document.documentElement.classList.toggle('body-lock-scroll-modal');
    setTimeout(() => {
        lightbox.classList.add('hidden');
    }, 300);
}

function openLightBox(lightbox) {
    lightbox.classList.remove('hidden');
    document.documentElement.classList.toggle('body-lock-scroll-modal');
    setTimeout(() => {
        lightbox.classList.remove('opacity-0');
        lightbox.classList.remove('pointer-events-none');
    }, 50);
}

function documentKeydownHandler(event, lightbox, splide) {
    if (!lightbox.classList.contains('hidden')) {
        if (event.key === "Escape") {
            closeLightBox(lightbox);
        }
        else if (event.key === "ArrowRight") {
            splide.go('+1');
        }
        else if (event.key === "ArrowLeft") {
            splide.go('-1');
        }
    }
}

function addSplideNavHandlers(navArrows, splide) {
    for ( let arrow of navArrows ) {
        arrow.addEventListener('click', () => {
            if (arrow.dataset.navigate === '+') {
                splide.go('+1');
            }
            else {
                splide.go('-1');
            }
        });
    }
}

function splideMountedMoveHandler(currentPostCounter, totalSlides, navArrows, splide) {
    if (currentPostCounter) {
        setTimeout(() => {
            currentPostCounter.textContent = (splide.index + 1).toString();
            for (let arrow of navArrows) {
                if (arrow.dataset.navigate === '+' && (splide.index + 1) === totalSlides) {
                    arrow.classList.add('!opacity-20', 'pointer-events-none');
                }
                else if (arrow.dataset.navigate === '+') {
                    arrow.classList.remove('!opacity-20', 'pointer-events-none');
                }

                if (arrow.dataset.navigate === '-' && (splide.index + 1) === 1) {
                    arrow.classList.add('!opacity-20', 'pointer-events-none');
                }
                else if (arrow.dataset.navigate === '-') {
                    arrow.classList.remove('!opacity-20', 'pointer-events-none');
                }
            }
        }, 50);
    }
}

window.addEventListener('load', () => {
    const homeHeroSplidePanel = document.querySelectorAll('.home-image-header-panel');
    let availableCarousels = document.querySelectorAll('.splide');
    let gallerySplidePanel = document.querySelectorAll('.gallery-panel');
    let instagramSplidePanel = document.querySelectorAll('.instagram-panel')
    let graphicSplidePanel = document.querySelectorAll('.graphic-panel');
    let eventSelectorPanel = document.querySelectorAll('.event-selector-panel');
    const cardPanel = document.querySelectorAll('.card-panel-slider');
    const mediaPanel = document.querySelectorAll('.media-panel');

    if (availableCarousels.length) {

        // START HOME MOVIE CARD SLIDER
        for ( const panel of homeHeroSplidePanel ) {
            let parentPanel = panel.closest('.home-image-header-panel');
            let currentCardCounter = parentPanel.querySelector('.card-splide-current-slide');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');
            let splideSlider = parentPanel.querySelector('.splide');

            if (splideSlider) {
                let totalSlides = parentPanel.querySelector('.splide').dataset.totalSlides;

                var homeHeroSplide = new Splide(panel.querySelector('.splide'), {
                    type: 'slide',
                    perPage: 3,
                    gap: '2rem',
                    perMove: 1,
                    arrows: false,
                    drag: false,
                    pagination: false,
                    padding: { left: '1rem', right: '1rem' },
                    classes: {
                        arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                        arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-green-neon-re fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                    breakpoints: {
                        1439: {
                            perPage: 3,
                            padding: { left: '2rem', right: '2rem' },
                        },
                        1023: {
                            drag: true,
                            arrows: true,
                            perPage: 2,
                            padding: { left: '1.5rem', right: '1.5rem' },
                        },
                        639: {
                            drag: true,
                            arrows: true,
                            perPage: 1,
                            padding: { left: '1.5rem', right: '1.5rem' },
                        },
                    },
                });

                for ( let arrow of navArrows ) {
                    arrow.addEventListener('click', () => {
                        if (arrow.dataset.navigate == '+') {
                            homeHeroSplide.go('+1');
                        }
                        else {
                            homeHeroSplide.go('-1');
                        }
                    });
                }

                homeHeroSplide.on('mounted move', function () {
                    if (currentCardCounter) {
                        const updateIndex = setTimeout(() => {
                            currentCardCounter.textContent = (homeHeroSplide.index + 1).toString();
                            for ( let arrow of navArrows ) {
                                if (arrow.dataset.navigate == '+' && (homeHeroSplide.index + 1) == totalSlides) {
                                    arrow.classList.add('!opacity-20');
                                }
                                else if (arrow.dataset.navigate == '+') {
                                    arrow.classList.remove('!opacity-20');
                                }

                                if (arrow.dataset.navigate == '-' && (homeHeroSplide.index + 1) == 1) {
                                    arrow.classList.add('!opacity-20');
                                }
                                else if (arrow.dataset.navigate == '-') {
                                    arrow.classList.remove('!opacity-20');
                                }
                            }
                        }, 50);
                    }
                });

                homeHeroSplide.mount();
            }
        }
        // END HOME MOVIE CARD SLIDER

        // START DATE SELECTOR SLIDER
        if (eventSelectorPanel.length) {
            let elementIndex = 0;
            if (window.location.hash.length > 1) {
                const performanceRef = window.location.hash.substring(1);
                const performanceSplide = document.querySelector(`li.splide__slide[data-performance="${performanceRef}"]`);

                if (performanceSplide) {
                    const siblings = [...performanceSplide.parentElement.children];
                    elementIndex = siblings.indexOf(performanceSplide);
                }
            }

            for ( let panel of eventSelectorPanel ) {
                let parentPanel = panel.closest('.event-selector-panel');

                let slideButtons = parentPanel.querySelectorAll('.splide__slide');
                const splideDateSelector = panel.querySelector('.splide-date-selector');
                if (splideDateSelector) {
                    let dateSelectorSplide = new Splide(splideDateSelector, {
                        start: elementIndex,
                        type: 'slide',
                        gap: '1rem',
                        autoWidth: 'true',
                        pagination: false,
                        perMove: 1,
                        arrows: true,
                        updateOnMove: true,
                        padding: { left: '1rem', right: '1rem' },
                        classes: {
                            arrows: 'splide__arrows absolute w-[6rem] h-max flex items-center justify-between flex top-0 gap-4 right-4 sm:right-6 lg:right-8',
                            arrow : 'splide__arrow relative z-5 bg-transparent p-0 w-10 h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                            prev  : 'splide__arrow--prev rotate-180',
                            next  : 'splide__arrow--next',
                        },
                    });

                    dateSelectorSplide.mount();

                    for ( let button of slideButtons ) {
                        button.addEventListener('click', (event) => {
                            dateSelectorSplide.go(parseInt(button.getAttribute('data-loopindex')));
                        });
                    }
                }

                const dateSelectors = parentPanel.querySelectorAll('button[data-ticketing][data-date]');
                const performanceAccordions = parentPanel.querySelectorAll('div.performance-cards > div');
                let nextButtons = parentPanel.querySelectorAll('.splide__arrow--next');
                let prevButtons = parentPanel.querySelectorAll('.splide__arrow--prev');

                function showHideDates() {
                    for (let dateSelector of dateSelectors) {
                        dateSelector.classList.remove('selected');
                        dateSelector.ariaSelected = 'false';
                    }
                    setTimeout(() => {
                        let newActive = panel.querySelector('.splide__slide.is-active > button');
                        if (newActive) {
                            newActive.classList.add('selected');
                            newActive.ariaSelected = 'true';

                            const selectedDate = newActive.getAttribute('data-date');
                            const datePerformanceCount = [...performanceAccordions].filter((performanceAccordion) => performanceAccordion.querySelector('button[data-date]').getAttribute('data-date') === selectedDate).length;

                            performanceAccordions.forEach((performanceAccordion) => {
                                const performanceCard = performanceAccordion.querySelector('button[data-date]');
                                const accordionContent = performanceAccordion.querySelector('.accordion-content');

                                if (performanceCard.getAttribute('data-date') === selectedDate) {
                                    performanceAccordion.classList.remove('hidden');
                                    performanceCard.classList.remove('hidden');

                                    const displayPricebands = datePerformanceCount > 1;

                                    if (!displayPricebands && accordionContent) {
                                        setAccordionCrossClasses(performanceAccordion,true);
                                        accordionContent.classList.remove('!max-h-[0]', 'hidden', 'opacity-0');
                                    }
                                } else {
                                    setAccordionCrossClasses(performanceAccordion,false);
                                    performanceAccordion.classList.add('hidden');
                                    performanceCard.classList.add('hidden');
                                    if (accordionContent) {
                                        accordionContent.classList.add('!max-h-[0]', 'hidden', 'opacity-0');
                                    }
                                }
                            });
                        }
                    }, 50);
                }

                showHideDates();

                for ( let button of nextButtons ) {
                    button.addEventListener('click', (event) => {
                        showHideDates();
                    });
                }


                for ( let button of prevButtons ) {
                    button.addEventListener('click', (event) => {
                        showHideDates();
                    });
                }
            }
        }
        // END DATE SELECTOR SLIDER

        // START GRAPHIC PANEL SLIDER
        for ( let panel of graphicSplidePanel ) {
            const parentPanel = panel.closest('.graphic-panel');
            const totalSlides = Number(parentPanel.querySelector('.graphic-splide').dataset.totalSlides);
            const currentPostCounter = parentPanel.querySelector('.graphic-splide-current-slide');
            const navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');

            const graphicSplide = new Splide(panel.querySelector('.graphic-splide'), {
                type: 'slide',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: false,
                padding: { left: '1.5rem', right: '1.5rem' },
                gap: '2rem',
            });

            addSplideNavHandlers(navArrows, graphicSplide);

            graphicSplide.on('mounted move', () => splideMountedMoveHandler(currentPostCounter, totalSlides, navArrows, graphicSplide));

            graphicSplide.mount();
        }
        // END GRAPHIC PANEL SLIDER

        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            const parentPanel = panel.closest('.gallery-panel');
            const galleryThumbnails = parentPanel.querySelectorAll('.gallery-panel-image');
            const lightbox = parentPanel.querySelector('.gallery-panel-lightbox');
            const lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            const lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            const totalSlides = Number(parentPanel.querySelector('.gallery-splide').dataset.totalSlides);
            const progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);
            const currentPostCounter = parentPanel.querySelector('.gallery-splide-current-slide');
            const navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');

            const lbox = new Splide(panel.querySelector('.gallery-lightbox-splide'), {
                type: 'fade',
                speed: 750,
                classes: {
                    arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                    arrow: 'splide__arrow relative z-5 rounded-l-lg w-14 h-16 p-2 bg-gray-900 bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                    next: 'splide__arrow--next right-0 2xl:-right-16',
                },
            });

            const gallerySplide = new Splide(panel.querySelector('.gallery-splide'), {
                ...DefaultSplideConfig,
                type: 'loop',
                gap: '.5rem',
                padding: { left: '0', right: '0' },
                breakpoints: {
                    1024: {
                        perPage: 3,
                        padding: { left: '0', right: '0' },
                        gap: '.5rem',
                    },
                    640: {
                        perPage: 2,
                        padding: { left: '0', right: '0' },
                    },
                    480: {
                        perPage: 1,
                        padding: { left: '0', right: '0' },
                    },
                },
                classes: {
                    arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                    arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-green-neon-re fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
            });

            // Closes lightbox on backdrop/close button press

            lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
            lightboxClose.addEventListener('click', () => closeLightBox(lightbox));

            // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'

            document.addEventListener("keydown", (e) => documentKeydownHandler(e, lightbox, lbox));

            // Opens lightbox and navigates carousel to the thumbnail that was pressed

            for ( let thumbnail of galleryThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        lbox.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox(lightbox);
                });
            }

            // Updates carousel progress bar width

            lbox.on('mounted move', function () {
                let end = lbox.Components.Controller.getEnd() + 1;
                progressBar.style.width = String(100 * (lbox.index + 1) / end) + '%';
            });

            addSplideNavHandlers(navArrows, gallerySplide);

            gallerySplide.on('mounted move', () => splideMountedMoveHandler(currentPostCounter, totalSlides, navArrows, gallerySplide));

            lbox.mount();
            gallerySplide.mount()
            gallerySplide.sync(lbox);
        }
        // END GALLERY PANEL SLIDER

        // START INSTAGRAM PANEL SLIDER
        for ( let panel of instagramSplidePanel ) {
            const parentPanel = panel.closest('.instagram-panel');
            const instagramThumbnails = parentPanel.querySelectorAll('.instagram-panel-image');
            const lightbox = parentPanel.querySelector('.instagram-panel-lightbox');
            const lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            const lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            const currentPostCounter = parentPanel.querySelector('.instagram-splide-current-slide');
            const navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');
            const totalSlides = Number(parentPanel.querySelector('.instagram-splide').dataset.totalSlides);
            const progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);

            const instagramSplide = new Splide(panel.querySelector('.instagram-splide'), {
                ...DefaultSplideConfig,
                type: 'loop',
                gap: '.5rem',
                padding: { left: '0', right: '0' },
                breakpoints: {
                    1024: {
                        perPage: 3,
                        padding: { left: '0', right: '0' },
                        gap: '.5rem',
                    },
                    640: {
                        perPage: 2,
                        padding: { left: '0', right: '0' },
                    },
                    480: {
                        perPage: 1,
                        padding: { left: '0', right: '0' },
                    },
                },
                classes: {
                    arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-8 lg:px-0',
                    arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-green-neon-re fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
            });

            const instagramLightbox = new Splide(panel.querySelector('.instagram-lightbox-splide'), {
                type: 'fade',
                speed: 750,
                classes: {
                    arrows: 'splide__arrows absolute w-full h-full items-center justify-between flex',
                    arrow: 'splide__arrow relative z-5 rounded-l-lg bg-gray-900 bg-opacity-20 md:bg-transparent p-0 w-10 h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                    next: 'splide__arrow--next right-0 2xl:-right-16',
                },
            });

            addSplideNavHandlers(navArrows, instagramSplide);

            for ( let thumbnail of instagramThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        instagramLightbox.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox(lightbox);
                });
            }

            if (lightbox) {
                // Closes lightbox on backdrop/close button press

                document.addEventListener("keydown", (e) => documentKeydownHandler(e, lightbox, instagramLightbox));

                instagramLightbox.on('mounted move', function () {
                    let end = instagramLightbox.Components.Controller.getEnd() + 1;
                    progressBar.style.width = String(100 * (instagramLightbox.index + 1) / end) + '%';
                });

                lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                lightboxClose.addEventListener('click', () => closeLightBox(lightbox));
            }

            instagramSplide.on('mounted move', () => splideMountedMoveHandler(currentPostCounter, totalSlides, navArrows, instagramSplide));

            instagramSplide.sync(instagramLightbox);
            instagramSplide.mount();
            instagramLightbox.mount();
        }
        // END INSTAGRAM PANEL SLIDER

        // START CARD PANEL SLIDER
        for ( const panel of cardPanel ) {
            const totalSlides = parseInt(panel.querySelector('.card-panel-splide').dataset.totalSlides);
            const paginationColor = panel.querySelector('.card-panel-splide').dataset.paginationColor;

            const cardSplide = new Splide(panel.querySelector('.card-panel-splide'), {
                type: 'loop',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: true,
                perPage: 3,
                pagination: true,
                autoplay: false,
                gap: '2rem',
                padding: '2rem',
                interval: 10000,
                destroy: totalSlides <= 3,
                classes: {
                    pagination: 'splide__pagination flex justify-center items-center gap-2 w-max !mx-auto pb-2',
                    page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&.is-active]:opacity-100 transition-all duration-150 ease-in-out border border-black' + ' ' + paginationColor,
                    arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 pb-4',
                    arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-green-neon-re fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1023: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides <= 2,
                    },
                    767: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                        destroy: totalSlides === 1,
                    },
                },
            });

            cardSplide.mount();
        }
        // END CARD PANEL SLIDER

        // START MEDIA IMAGE PANEL SLIDER
        for ( const panel of mediaPanel ) {
            const mediaImageLightbox = panel.querySelector('[data-media-image-lightbox]');
            const paginationColour = 'bg-black';
            const slideCount = panel.querySelector('.media-image-splide')?.dataset.totalSlides;
            const lightBoxSlideCount = panel.querySelector('.media-image-lightbox-splide')?.dataset.totalSlides;
            const splideCounterContainer = panel.querySelector('[data-slider="image"] [data-splide-counter-container]');

            // might not always be an image slider
            if (panel.querySelector('.media-image-splide')) {
                const mediaImageSplide = new Splide(panel.querySelector('.media-image-splide'), {
                    autoplay: false,
                    type: 'loop',
                    speed: 750,
                    gap: '1rem',
                    destroy: slideCount === '1',
                    arrows: true,
                    pagination: false,
                    classes: {
                        pagination: 'splide__pagination flex justify-center items-center gap-2 w-max h-12 mt-6 lg:mt-10 mx-auto',
                        page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&:not(.is-active)]:bg-current [&.is-active]:opacity-100 transition-all duration-150 ease-in-out' + ' ' + paginationColour,
                        arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                        arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-green-neon-re fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                });

                const mediaImageLightboxSplide = new Splide(panel.querySelector('.media-image-lightbox-splide'), {
                    type: 'fade',
                    speed: 750,
                    pagination: false,
                    destroy: lightBoxSlideCount === '1',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                        arrow: 'splide__arrow relative z-5 rounded-l-lg w-14 h-16 p-2 bg-black bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                        next: 'splide__arrow--next right-0 2xl:-right-16',
                    },
                });

                panel.addEventListener('click', () => {
                    const clickedEventItem = event.target;

                    // Closes lightbox on backdrop/close button press
                    if (clickedEventItem.hasAttribute('data-lightbox-backdrop') || clickedEventItem.hasAttribute('data-lightbox-close')) {
                        closeLightBox();
                    }

                    // Sets lightbox slide to clicked image
                    if (clickedEventItem.hasAttribute('data-media-image') && clickedEventItem.hasAttribute('data-slide')) {
                        openLightBox();
                        mediaImageLightboxSplide.go(parseInt(clickedEventItem.dataset.slide));
                    }
                });


                function closeLightBox() {
                    mediaImageLightbox.dataset.active = 'false';
                    // unlockBody();
                    setTimeout(() => {
                        mediaImageLightbox.dataset.hidden = 'true';
                    }, 300);
                }

                function openLightBox() {
                    mediaImageLightbox.dataset.hidden = 'false';
                    // lockBody();
                    setTimeout(() => {
                        mediaImageLightbox.dataset.active = 'true';
                    }, 50);
                }

                if (splideCounterContainer) {
                    const splideCounter = splideCounterContainer.querySelector('p');

                    mediaImageSplide.on('mounted move', function () {
                        const totalSlides = mediaImageSplide.length;
                        const activeIndex = mediaImageSplide.index + 1;

                        splideCounter.innerHTML = activeIndex + ' of ' + totalSlides;
                    });
                }

                if (mediaImageLightbox) {
                    const progressBar = mediaImageLightbox.querySelector('[data-carousel-progress]');

                    // Updates carousel progress bar width
                    mediaImageLightboxSplide.on('mounted move', function () {
                        const end = mediaImageLightboxSplide.Components.Controller.getEnd() + 1;
                        progressBar.style.width = String(100 * (mediaImageLightboxSplide.index + 1) / end) + '%';
                    });

                    // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'
                    document.addEventListener('keydown', (e) => {
                        if (mediaImageLightbox.dataset.hidden !== 'true') {
                            if (e.key === 'Escape') {
                                closeLightBox();
                            }
                            else if (e.key === 'ArrowRight') {
                                mediaImageLightboxSplide.go('+1');
                            }
                            else if (e.key === 'ArrowLeft') {
                                mediaImageLightboxSplide.go('-1');
                            }
                        }
                    });
                }

                mediaImageLightboxSplide.mount();
                mediaImageSplide.mount()
            }
        }
        // END MEDIA IMAGE PANEL SLIDER

        // START MEDIA VIDEO PANEL SLIDER
        for ( const panel of mediaPanel ) {
            const mediaVideoLightbox = panel.querySelector('[data-media-video-lightbox]');
            const paginationColour = 'bg-black';
            const slideCount = panel.querySelector('.media-video-splide')?.dataset.totalSlides;
            const splideCounterContainer = panel.querySelector('[data-slider="video"] [data-splide-counter-container]');

            // might not always be an video slider
            if (panel.querySelector('.media-video-splide')) {
                const mediaVideoSplide = new Splide(panel.querySelector('.media-video-splide'), {
                    autoplay: false,
                    type: 'fade',
                    speed: 750,
                    gap: '1rem',
                    destroy: slideCount === '1',
                    pagination: false,
                    arrows: true,
                    classes: {
                        pagination: 'splide__pagination flex justify-center items-center gap-2 w-max h-12 mt-6 lg:mt-10 mx-auto',
                        page: 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 opacity-50 hover:scale-105 [&:not(.is-active)]:bg-current [&.is-active]:opacity-100 transition-all duration-150 ease-in-out' + ' ' + paginationColour,
                        arrows: 'splide__arrows absolute bottom-0 left-0 w-full h-12 flex items-center justify-between px-6 lg:px-8 1.5xl:px-0',
                        arrow: 'splide__arrow relative z-5 rounded-full w-12 h-12 p-4 bg-green-neon-re fill-current text-black disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 active:!duration-75 active:!scale-125 disabled:!scale-100 disabled:!opacity-20',
                        prev: 'splide__arrow--prev rotate-180',
                        next: 'splide__arrow--next',
                    },
                });

                const mediaVideoLightboxSplide = new Splide(panel.querySelector('.media-video-lightbox-splide'), {
                    type: 'fade',
                    speed: 750,
                    pagination: false,
                    destroy: slideCount === '1',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                        arrow: 'splide__arrow relative z-10 rounded-l-lg w-14 h-16 p-2 bg-black bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                        next: 'splide__arrow--next right-0 2xl:-right-16',
                    },
                });

                if (splideCounterContainer) {
                    const splideCounter = splideCounterContainer.querySelector('p');

                    mediaVideoSplide.on('mounted move', function () {
                        const totalSlides = mediaVideoSplide.length;
                        const activeIndex = mediaVideoSplide.index + 1;

                        splideCounter.innerHTML = activeIndex + ' of ' + totalSlides;
                    });
                }

                panel.addEventListener('click', () => {
                    const clickedEventItem = event.target;

                    // Closes lightbox on backdrop/close button press
                    if (clickedEventItem.hasAttribute('data-lightbox-backdrop') || clickedEventItem.hasAttribute('data-lightbox-close')) {
                        closeLightBox();
                    }

                    // Sets lightbox slide to clicked image
                    if (clickedEventItem.hasAttribute('data-media-video') && clickedEventItem.hasAttribute('data-slide')) {
                        openLightBox();
                        mediaVideoLightboxSplide.go(parseInt(clickedEventItem.dataset.slide));
                    }
                });

                function closeLightBox() {
                    mediaVideoLightbox.dataset.active = 'false';
                    mediaVideoLightbox.querySelectorAll('iframe,video').forEach((playerElement) => {
                        const mediaType = playerElement.getAttribute('data-media-type').toLowerCase();

                        switch (mediaType) {
                            case 'youtube':
                                playerElement.contentWindow.postMessage(
                                    JSON.stringify({
                                        event: 'command',
                                        func: 'stopVideo'
                                    }),
                                    '*'
                                );
                                break;

                            case 'vimeo':
                                playerElement.contentWindow.postMessage(
                                    JSON.stringify({
                                        method: 'pause',
                                    }),
                                    '*'
                                );
                                break;

                            case 'file':
                                playerElement.pause();
                                playerElement.currentTime = 0;
                                break;
                        }
                    });

                    // unlockBody();
                    setTimeout(() => {
                        mediaVideoLightbox.dataset.hidden = 'true';
                    }, 300);
                }

                function openLightBox() {
                    mediaVideoLightbox.dataset.hidden = 'false';
                    // lockBody();
                    setTimeout(() => {
                        mediaVideoLightbox.dataset.active = 'true';
                    }, 50);
                }

                if (mediaVideoLightbox) {
                    const progressBar = mediaVideoLightbox.querySelector('[data-carousel-progress]');

                    // Updates carousel progress bar width
                    mediaVideoLightboxSplide.on('mounted move', function () {
                        const end = mediaVideoLightboxSplide.Components.Controller.getEnd() + 1;
                        progressBar.style.width = String(100 * (mediaVideoLightboxSplide.index + 1) / end) + '%';
                    });

                    // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'
                    document.addEventListener('keydown', (e) => {
                        if (mediaVideoLightbox.dataset.hidden !== 'true') {
                            if (e.key === 'Escape') {
                                closeLightBox();
                            }
                            else if (e.key === 'ArrowRight') {
                                mediaVideoLightboxSplide.go('+1');
                            }
                            else if (e.key === 'ArrowLeft') {
                                mediaVideoLightboxSplide.go('-1');
                            }
                        }
                    });
                }

                mediaVideoSplide.sync(mediaVideoLightboxSplide);
                mediaVideoLightboxSplide.mount();
                mediaVideoSplide.mount()
            }

        }
        // END MEDIA VIDEO PANEL SLIDER
    }
});
